module.exports = __webpack_public_path__ + "img/close.66fc576f.svg";